export const CONFIG_LAYER = {
	ASSET_CLASS_COLORS: {
		'Empty': '#dddddd',
		'US Equities': '#6E3FA3',
		'Non-US/International Equities': '#8F63BC',
		'International/Global Equities': '#B287DF',
		'International Equities': '#B287DF',
		'Sector Equities': '#C7B2DE',
		'Sector Equity': '#C7B2DE',
		'US Fixed Income': '#008B5C',
		'Non-US/International Fixed Income': '#00AE73',
		'International/Global Fixed Income': '#9CD7BD',
		'Global Fixed Income': '#9CD7BD',
		'Multi Asset': '#FC9BB3',
		'Multi-Asset': '#FC9BB3',
		'Alternatives': '#CC0018',
		'Alternative': '#CC0018',
		'Cash': '#FFCE00',
		'Cash & Cash Alternatives': '#FFCE00',
		'Default': '#772654',
		'Other': '#A5A5A5'
	},
	HIGHLIGHTED_FILTERS_ICON: {
		'growth': 'economic-growth',
		'income': 'income',
		'capital_preservation': 'protection',
		'esg': 'esg',
		'tax_aware': 'savings',
		'alternatives': 'diversification'
	},
	MODELS_DISPLAY_ORDER_ON_SLIDER_ON_RISK_PROFILE: { 'conservative': 1, 'moderate_conservative': 2, 'moderate': 3, 'moderate_aggressive': 4, 'aggressive': 5 },
	EXPLORE_CARD_FILTERS: ['growth', 'income', 'capital_preservation'],
	HOME_PAGE_LEFT_NAV: {
		'growth': ['mutual_fund_and_etf', 'all_etf', 'tax_aware', 'alternatives', 'high_net_growth'],
		'income': ['mutual_fund_and_etf', 'all_etf', 'tax_aware'],
		'capital_preservation': ['mutual_fund_and_etf', 'all_etf', 'tax_aware', 'alternatives', 'high_net_growth']
	},
	HOME_PAGE_SELECTED_CARD_FAMILIES_PER_CATEGORY: {
		'growth': {
			'all_etf': [
				{ 'familyId': '893186' },
				{ 'familyId': '905573' }
			],
			'mutual_fund_and_etf': [
				{ 'familyId': '905531' },
				{ 'familyId': '905570' },
				{ 'familyId': '893184' },
				{ 'familyId': '905533' }
			],
			'tax_aware': [
				{ 'familyId': '905559' },
				{ 'familyId': '905530' },
				{ 'familyId': '905567' },
				{ 'familyId': '905569' },
				{ 'familyId': '905534' },
				{ 'familyId': '905532' }
			],
			'alternatives': [
				{ 'familyId': '905570' }
			],
			'high_net_growth': [
				{ 'familyId': '905566' },
				{ 'familyId': '905569' }
			]
		},
		'income': {
			'all_etf': [
				{ 'familyId': '905564' }
			],
			'mutual_fund_and_etf': [
				{ 'familyId': '893184' },
				{ 'familyId': '905533' },
				{ 'familyId': '918480' }
			],
			'tax_aware': [
				{ 'familyId': '905534' },
				{ 'familyId': '905532' }
			]
		},
		'capital_preservation': {
			'all_etf': [
				{ 'familyId': '893186' },
				{ 'familyId': '905573' }
			],
			'mutual_fund_and_etf': [
				{ 'familyId': '905533' },
				{ 'familyId': '905531' },
				{ 'familyId': '893184' },
				{ 'familyId': '905570' }
			],
			'tax_aware': [
				{ 'familyId': '905559' },
				{ 'familyId': '905530' },
				{ 'familyId': '905567' },
				{ 'familyId': '905532' },
				{ 'familyId': '905569' }
			],
			'alternatives': [
				{ 'familyId': '905570' }
			],
			'high_net_growth': [
				{ 'familyId': '905566' },
				{ 'familyId': '905569' }
			]
		}
	},
	DROP_DOWN_FILTERS: [
		{
			'meFilterId': 'riskProfile',
			'meFilterKey': 'riskProfile',
			'meFilterName': 'Risk Tolerance',
			'meFilterGroup': 'Standard',
			'applicability': 'portfolio',
			'options': ['conservative', 'moderate conservative', 'moderate', 'moderate aggressive', 'aggressive']
		}, {
			'meFilterId': 'tradeFrequency',
			'meFilterKey': 'tradeFrequency',
			'meFilterName': 'Trading Frequency',
			'meFilterGroup': 'Standard',
			'applicability': 'family',
			'options': ['monthly', 'quarterly', 'semi-annually', 'annual']
		}, {
			'meFilterId': 'vehicle',
			'meFilterKey': 'vehicle',
			'meFilterName': 'Underlying Investment Vehicle(s)',
			'meFilterGroup': 'Standard',
			'applicability': 'family',
			'options': ['etf only', 'etf and mf', 'mf only']
		}, {
			'meFilterId': 'openArchitecture',
			'meFilterKey': 'openArchitecture',
			'meFilterName': '3rd Party Funds',
			'meFilterGroup': 'More Filters',
			'applicability': 'family',
			'options': ['open', 'closed']
		}, {
			'meFilterId': 'modelCategoryType',
			'meFilterKey': 'modelCategoryType',
			'meFilterName': 'BlackRock Management Team',
			'meFilterGroup': 'More Filters',
			'applicability': 'family',
			'options': ['mas - mps managed models', 'mas - income', 'pmg fi - global allocation']
		}, {
			'meFilterId': 'growth',
			'meFilterKey': 'objective',
			'meFilterName': 'Growth',
			'meFilterGroup': 'highlighted',
			'applicability': 'portfolio',
			'options': ['aggressive', 'moderate', 'aggressive with higher income', 'moderate with higher income']
		}, {
			'meFilterId': 'income',
			'meFilterKey': 'objective',
			'meFilterName': 'Income',
			'meFilterGroup': 'highlighted',
			'applicability': 'portfolio',
			'options': ['moderate with higher income', 'aggressive with higher income', 'conservative with higher income']
		}, {
			'meFilterId': 'capital_preservation',
			'meFilterKey': 'objective',
			'meFilterName': 'Capital Preservation',
			'meFilterGroup': 'highlighted',
			'applicability': 'portfolio',
			'options': ['conservative', 'conservative with higher income']
		}, {
			'meFilterId': 'esg',
			'meFilterKey': 'preferences',
			'meFilterName': 'ESG',
			'meFilterGroup': 'highlighted',
			'applicability': 'family',
			'options': ['esg']
		}, {
			'meFilterId': 'tax_aware',
			'meFilterKey': 'preferences',
			'meFilterName': 'Tax Aware',
			'meFilterGroup': 'highlighted',
			'applicability': 'family',
			'options': ['tax aware']
		}, {
			'meFilterId': 'alternatives',
			'meFilterKey': 'preferences',
			'meFilterName': 'Alternatives',
			'meFilterGroup': 'highlighted',
			'applicability': 'family',
			'options': ['alternatives']
		}
	],
	SHOW_DOWNLOAD_HOLDINGS_BUTTON_ON_FIND_AND_COMPARE: true,
	ENABLE_DOWNLOAD_HOLDINGS_MODULARITY: true,
	SHOW_DOWNLOAD_ALL_PDF_BUTTON: false,
	CWP_COMPONENTS: {
		routes: [
			{
				'path': '',
				'components': [
					{
						'id': 'w1723613696045',
						'order': 1
					}, {
						'id': 'w1723613696052',
						'order': 2
					},
					{
						'id': 'w1723613696055',
						'order': 5
					},
					{
						'id': 'w1750313180840',
						'order': 6
					},
					{
						'id': 'w1750313180842',
						'order': 7
					},
					{
						'id': 'w1750313180841',
						'order': 8
					}
				]
			},
			{
				'path': 'find-and-compare-models',
				'components': [
					{
						'id': 'w1730978132357',
						'order': 1
					}
				]
			}
		]
	},
	DROPDOWN_FILTER_MAPPING: {
		'all_etf': 'etf only',
		'mutual_fund_and_etf': 'etf and mf',
		'tax_aware': 'tax aware',
		'sustainable': 'esg',
		'high_net_growth': ''
	},
	SHOW_MODEL_LIST_PERFORMANCE_DISCLOSURE: false,
	MODEL_CATEGORY_MAPPING: {
		'mas - mps managed models': 'ta_models',
		'mas - lifepath': 'ta_models',
		'pmg fi - global allocation': 'ga_models',
		'mas - income': 'mai_models'
	},
	PDF_INVESTMENT_PAGES_MAPPING: {
		'mas - mps managed models': 'ta_models',
		'pmg fi - global allocation': 'ga_models',
		'mas - income': 'mai_models'
	},
	SHOW_INVESTMENT_PDF_PAGES: false,
	PERFORMANCE_BOX_DISCLOSURE_ENABLED_FOR_BLK_GROUP_FAMILY: ['MCUF_WAQ', 'MPUF_TAH'], // aladdinTicker is used as an Identifier.
	SHOW_MODEL_OVERVIEW_PDF_PAGE: false,
	SHOW_CMS_PDF_MODULARITY: false,
	ENABLE_CUSTOM_FEE: true,
	HOLDINGS_TABLE_HEADER_COLUMNS: ['expenseRatio', 'grossExpenseRatio'],
	LATEST_HOLDINGS_HEADER_COLUMNS: [
		{
			headerDcr: 'NET_EXPENSE_RATIO',
			headerFallbackText: 'Net Expense Ratio (%)',
			tooltipDcr: 'NET_EXP_RATIO_TOOLTIP',
			field: 'expenseRatio'
		},
		{
			headerDcr: 'GROSS_EXPENSE_RATIO',
			headerFallbackText: 'Gross Expense Ratio (%)',
			tooltipDcr: 'GROSS_EXP_RATIO_TOOLTIP',
			field: 'grossExpenseRatio'
		}
	],
	FAMILY_DETAILS_TAB: [
		{ route: 'latest-holdings', label: { dcrKey: 'FAMILY_LATEST_HOLDINGS_LABEL', dcrValue: 'Latest Holdings (%)' } },
		{ route: 'changes-holdings', label: { dcrKey: 'FAMILY_CHANGES_HOLDINGS_LABEL', dcrValue: 'Changes to Holdings (%)' } },
		{ route: 'commentary', label: { dcrKey: 'FAMILY_COMMENTARY_LABEL', dcrValue: 'Trade Rationale' } },
		{ route: 'performance-commentary', label: { dcrKey: 'FAMILY_PERFORMANCE_COMMENTARY_LABEL', dcrValue: 'Performance Commentary' } },
		{ route: 'performance', label: { dcrKey: 'FAMILY_PERFORMANCE_LABEL', dcrValue: 'Performance (%)' } },
		{ route: 'additional-resources', label: { dcrKey: 'FAMILY_ADDITIONAL_RESOURCES_LABEL', dcrValue: 'Additional Resources' } }
	],
	RISK_PROFILE_KEYS: [
		'expenseRatio', 'ytdReturn', 'customNetYearToDate', '12mTrailingYield', 'estimatedRisk'
	],
	SHOW_DROPDOWN_FILTERS_MORE_LESS_BUTTON: true,
	SHOW_SEARCH_BUTTON: true,
	ENABLE_PERFORMANCE_BENCHMARK: true,
	SHOW_FUND_PERF_TABLE_LINK: true,
	MULTI_ROW_LEFT_HEADER: false,
	SHOW_BRAND_AND_SHARE_LINK: false,
	SHOULD_LOAD_MODEL_FAMILIES_FROM_IRETIRE_SERVER: false,
	NUMBER_OF_MODELS_FOR_COMPARISON: 5,
	REDIRECT_TO_ACT2: true,
	DETAIL_LINK_KEYS: ['FUND_PERFORMANCE_AND_FEES', 'MODEL_FAMILY_DETAILS'],
	ACT2_PATHS: {
		FIND_AND_COMPARE_PAGE: 'https://www.blackrock.com/advisor-center-360/?location=/model-evaluator/blackrock_models/0&pkg=UAP_DLY#/model-evaluator/blackrock_models/0',
		MODEL_FAMILY_DETAILS: 'https://www.blackrock.com/advisor-center-360/?location=/model-evaluator/model-family-details/model/blackrock_models/0/$$pathName$$&fg=metadata.account.FAMILY_ID:$$familyId$$:IN,metadata.account.SUBTYPE:BLK:IN&pkg=UAP_DLY#/model-evaluator/model-family-details/model/blackrock_models/0/$$pathName$$',
		FUND_PERFORMANCE_AND_FEES: 'https://www.blackrock.com/advisor-center-360/?location=/model-evaluator/model-family-details/model/blackrock_models/0/fund-performance-fees&fg=metadata.account.FAMILY_ID:$$familyId$$:IN,metadata.account.SUBTYPE:BLK:IN&pkg=UAP_DLY#/model-evaluator/model-family-details/model/blackrock_models/0/fund-performance-fees',
		COMPARE_URL: 'https://www.blackrock.com/advisor-center-360/?location=/model-evaluator/blackrock_models/0/comparison/overview&comparisonIds=$$modelIds$$&pkg=UAP_DLY#/model-evaluator/blackrock_models/0/comparison/overview',
		DEEP_DIVE_URL: 'https://www.blackrock.com/advisor-center-360/?location=/model-evaluator/model-family-details/model/blackrock_models/0/latest-holdings&fg=metadata.account.FAMILY_ID:$$familyId$$:IN,metadata.account.SUBTYPE:BLK:IN&pkg=UAP_DLY#/model-evaluator/model-family-details/model/blackrock_models/0/latest-holdings',
		PORTFOLIO_ANALYSER_URL: 'https://www.blackrock.com/advisor-center-360/?location=/comparison/overview&comparisonIds=MODEL_ID:WTS_$$portfolioId$$&portfolioSelection=true&pkg=UAP_DLY#/comparison/overview',
		FUND_PERFORMANCE_AND_FEES_CMS: 'https://www.blackrock.com/advisor-center-360/?location=/model-evaluator/model-family-details/entitledModel/my_custom_models/0/fund-performance-fees&fg=metadata.account.FAMILY_ID:$$familyId$$:IN,metadata.account.SUBTYPE:CMS|BLK:IN&pkg=UAP_DLY#/model-evaluator/model-family-details/entitledModel/my_custom_models/0/fund-performance-fees',
		MODEL_FAMILY_DETAILS_CMS: 'https://www.blackrock.com/advisor-center-360/?location=/model-evaluator/model-family-details/entitledModel/my_custom_models/0/$$pathName$$&fg=metadata.account.FAMILY_ID:$$familyId$$:IN,metadata.account.SUBTYPE:CMS|BLK:IN&pkg=UAP_DLY#/model-evaluator/model-family-details/entitledModel/my_custom_models/0/$$pathName$$'
	}
};
